import { CheckBox } from 'types/appContext';

/**
 * Get unique OM filter data by removing duplicates
 * @param omData - Array of CheckBox items i.e.. Divisions or Cost Centres data
 * @returns Filtered array with unique items
 */
export const getUniqueOMData = (omData: CheckBox[]) => omData
    .filter((item, index, self) => self.findIndex(indx => indx.value === item.value && indx.label === item.label) === index);
